import { render, staticRenderFns } from "./ResizableContainer.vue?vue&type=template&id=1d154e76&scoped=true&"
import script from "./ResizableContainer.vue?vue&type=script&lang=js&"
export * from "./ResizableContainer.vue?vue&type=script&lang=js&"
import style0 from "./ResizableContainer.vue?vue&type=style&index=0&id=1d154e76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d154e76",
  null
  
)

export default component.exports